/* eslint-disable no-unused-vars */
var canRunAds2 = true;